import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { H6, Image, P } from "../../../../AbstractElements";
import { ScrollableContentTitle } from "../../../../Constants/Constants";
import { ScrollContentSubTitle, ScrollableContentData } from "../../../../Data/BonusUi/Scrollable";
import { dynamicImage } from "../../../../Utils";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ScrollBar from "react-perfect-scrollbar";

const ScrollableContent = () => {
  return (
    <Col xxl="4" md="12">
      <Card>
        <CommonCardHeader title={ScrollableContentTitle} span={ScrollContentSubTitle} />
        <CardBody>
          <ScrollBar className="vertical-scroll scroll-demo scroll-b-none custom-container">
            <ListGroup className="main-lists-content">
              {ScrollableContentData &&
                ScrollableContentData.map((item, index) => (
                  <ListGroupItem action className={` ${index === 0 ? "active bg-list-hover-primary" : "list-hover-primary"}`} key={index}>
                    <div className="list-wrapper gap-0">
                      <Image className="list-img" src={dynamicImage(`user/${item.image}`)} alt="profile" />
                      <div className="list-content">
                        <H6>{item.head}</H6>
                        <P>{item.mail}</P>
                        <small className={index !== 0 ? "text-muted" : ""}>{item.small}</small>
                      </div>
                    </div>
                  </ListGroupItem>
                ))}
            </ListGroup>
          </ScrollBar>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ScrollableContent;
